export default {
    dashboardWidgetItem: {
      list: "Danh sách Dashboard Widget Item",
      update: "Thông tin Dashboard Widget Item",
      create: "Thông tin Dashboard Widget Item",
    },
  }